import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntryByTitle} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {isServer} from '../../utils/utils'
import {extractLabels} from '../../utils/labels-utils'

export const useGetContentByTitle = (title) => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()
    const getContent = async () => {
        const response = await getEntryByTitle({
            stack,
            contentTypeUid: 'labels',
            title: title,
            locale: locale.alias,
            referenceFieldPath: ['siblings'],
        })

        const labels = extractLabels(response)
        return labels
    }
    return useQuery(['contentstackGetTechSpecs', title], () => getContent(), {enabled: !isServer})
}
